import React, { lazy, Suspense } from "react";
import logo from "./logo.svg";
import "./App.scss";
import { Route, Router, Routes, useNavigate } from "react-router-dom";
import Login from "./Pages/Login/Login.lazy";
import Dashboard from "./Pages/Dashboard/Dashboard.lazy";
import SignUp from "./Pages/SignUp/SignUp.lazy";
import ProjectWizard from "./Pages/ProjectWizard/ProjectWizard.lazy";
import ReduxSample from "./Pages/ReduxSample/ReduxSample.lazy";
import { Header } from "./Components/header.component";
import { SessionService } from "./Services/session.service";
import ContactDetail from "./Pages/Contact/ContactDetail/ContactDetail.lazy";
import SideBar from "./Pages/SideBar/SideBar";
import {
  AppBar,
  AppBarProps,
  Box,
  CssBaseline,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Estimates from "./Pages/Estimates/Estimates.lazy";
import ProjectPreview from "./Pages/ProjectPreview/ProjectPreview.lazy";
// import AddEstimatesLazy from "./Pages/Estimates/AddEstimates/Estimates/AddEstimates.lazy";
import AddEstimates from "./Pages/Estimates/AddEstimates/AddEstimates.lazy";
import Products from "./Pages/Products/Products.lazy";
import AddProduct from "./Pages/Products/AddProduct/AddProduct.lazy";
import Sales from "./Pages/Sales/Sales.lazy";
import Tasks from "./Pages/Tasks/Tasks.lazy";
import AddSale from "./Pages/Sales/AddSale/AddSale.lazy";
import AddPurchase from "./Pages/Purchase/AddPurchase/AddPurchase.lazy";
import Purchase from "./Pages/Purchase/Purchase.lazy";
import PropertyComponent from "./Pages/Property/Property.lazy";
import LazyPayment from "./Pages/Payment/Payment.lazy";
import Contact from "./Pages/Contact/Contact";
import Payment from "./Pages/Payment/Payment";
// import PaymentReceived from "./Pages/Payment/PaymentReceived/PaymentReceived";
import PaymentReceived from "./Pages/Payment/PaymentReceived/PaymentReceived";
import PaymentPayable from "./Pages/Payment/PaymentPayable/PaymentPayable";
import Leads from "./Pages/Leads/Leads";
import AddLeads from "./Pages/Leads/AddLeads/AddLeads";
import Activity from "./Pages/Activity/Activity.lazy";
import { LoadingProvider } from "./Shared/services/loading-context";
import Expanse from "./Pages/Expanse/Expanse.lazy";
import AddExpanse from "./Pages/Expanse/AddExpanse/AddExpanse.lazy";
import { SnackbarProvider } from 'notistack';
import UserComponent from "./Pages/User/User.lazy";
import AddUser from "./Pages/User/AddUser/AddUser.lazy";
import RoleUserManagement from "./Pages/RoleUserManagement/RoleUserManagement.lazy";
import AddRole from "./Pages/Role/AddRole/AddRole.lazy";
import ApproveUser from "./Pages/ApproveUser/ApproveUser.lazy";
import { PermissionList } from "./Shared/consts/permissions";
import ProjectRequests from "./Pages/ProjectRequests/ProjectRequests.lazy";
import ApproveRequests from "./Pages/ApproveRequests/ApproveRequests.lazy";
import ContactView from "./Pages/ContactView/ContactView.lazy";
import SettingComponent from "./Pages/Setting/Setting.lazy";
import ReportComponent from "./Pages/Report/Report.lazy";

// import Payment from "./Pages/Payment/Payment";
// import { AddEstimates } from "./Pages/Estimates/AddEstimates/Estimates/AddEstimates.stories";
// To lazy load component at routing.
const SignUpLazy = lazy(() => import("././Pages/SignUp/SignUp"));

const drawerWidth = 10;

function App() {
  const token = SessionService.token();
  // const token = () => {
  //   return "";
  // };
  const [open, setOpen] = React.useState(true);
  const [permissions, setPermissions] = React.useState<string[]>([]);
  const navigate = useNavigate();

  React.useEffect(() => {
    const permissionArray = SessionService.user()?.permissions;
    setPermissions(permissionArray);
  }, []);

  const handleDrawerToggle = () => {
    setOpen((prevValue) => !prevValue);
  };

  const Main = styled("main", {
    shouldForwardProp: (prop) => prop !== "open",
  })<{
    open?: boolean;
  }>(({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  }));

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  }));

  interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
  }

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
  })<AppBarProps>(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

  const RoutingComponent = (Component: any, permission: string, noBootstrap?: boolean) => {
    //if(!permissions.includes(permission)) navigate("/");
    return (
      <>
        {/* #doubt noBootstrap */}
        {noBootstrap ?
          (!permissions.includes(permission) ? <Dashboard /> : <Component />)
          : (
            <Box sx={{ display: "flex" }}>
              {/* #doubt CssBaseline */}
              <CssBaseline />
              <AppBar position="fixed" open={false}>
                <Header handleDrawerToggle={handleDrawerToggle} />
              </AppBar>
              <SideBar open={open} />
              {/* <Main className="app-main" open={open}> */}
              <div className={open ? "app-main isOpen" : 'app-main'}>
                <DrawerHeader />
                {!permissions.includes(permission) ? <Dashboard /> : <Component />}
              </div>
              {/* </Main> */}
            </Box>
          )}
      </>
    );
  };
  return (
    <LoadingProvider>
      <SnackbarProvider maxSnack={3} anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}>
        <div className="App">
          {token ? (
            <>
              <Routes>
                <Route path="/dashboard" element={RoutingComponent(Dashboard, PermissionList.DashboardPermissions.get)} />
                <Route path="/approve" element={RoutingComponent(ApproveRequests, PermissionList.ApprovePermissions.get)} />

                <Route path="/tasks" element={RoutingComponent(Tasks, PermissionList.TaskPermissions.get)} />

                <Route
                  path="/projectdetails"
                  element={RoutingComponent(ProjectWizard, PermissionList.ProjectPermissions.get, true)}
                />
                <Route
                  path="/projectdetails/:userId"
                  element={RoutingComponent(ProjectWizard, PermissionList.ProjectPermissions.get, true)}
                />

                <Route
                  path="/redux-sample"
                  element={RoutingComponent(ReduxSample, String())}
                />

                <Route path="/contact" element={RoutingComponent(Contact, PermissionList.ContactPermissions.get)} />

                <Route
                  path="/contact/contactDetail"
                  element={RoutingComponent(ContactDetail, PermissionList.ContactPermissions.get)}
                />

                <Route
                  path="/contactDetail/:id"
                  element={RoutingComponent(ContactDetail, PermissionList.ContactPermissions.get)}
                />
                
                <Route
                  path="/contact-view/:contactId"
                  element={RoutingComponent(ContactView, PermissionList.ContactPermissions.get)}
                />

                <Route path="/payment" element={RoutingComponent(Payment, PermissionList.PaymentPermissions.get)} />

                <Route
                  path="/payment/paymentReceived"
                  element={RoutingComponent(PaymentReceived, PermissionList.PaymentPermissions.get)}
                />
                <Route
                  path="/payment/paymentPayable"
                  element={RoutingComponent(PaymentPayable, PermissionList.PaymentPermissions.get)}
                />

                <Route path="/estimates" element={RoutingComponent(Estimates, PermissionList.EstimatePermissions.get)} />
                <Route path="/leads" element={RoutingComponent(Leads, PermissionList.LeadPermissions.get)} />
                <Route
                  path="/leads/addleads"
                  element={RoutingComponent(AddLeads, PermissionList.LeadPermissions.get)}
                />
                <Route path="/leads/:id" element={RoutingComponent(AddLeads, PermissionList.LeadPermissions.get)} />

                <Route
                  path="/estimates/addestimate"
                  element={RoutingComponent(AddEstimates, PermissionList.EstimatePermissions.get)}
                />

                <Route path="/activity" element={RoutingComponent(Activity, PermissionList.ActivityPermissions.get)} />
                <Route path="/reports" element={RoutingComponent(ReportComponent, PermissionList.ActivityPermissions.get)} />

                <Route
                  path="/estimates/:id"
                  element={RoutingComponent(AddEstimates, PermissionList.EstimatePermissions.get)}
                />

                <Route
                  path="/property"
                  element={RoutingComponent(PropertyComponent, PermissionList.ProjectPermissions.get)}
                />
                
                <Route
                  path="/settings"
                  element={RoutingComponent(SettingComponent, PermissionList.ProjectPermissions.get)}
                />

                <Route path="/products" element={RoutingComponent(Products, PermissionList.ProductPermissions.get)} />

                <Route
                  path="/products/add"
                  element={RoutingComponent(AddProduct, PermissionList.ProductPermissions.get)}
                />

                <Route
                  path="/products/:id"
                  element={RoutingComponent(AddProduct, PermissionList.ProductPermissions.get)}
                />

                <Route path="/sales" element={RoutingComponent(Sales, PermissionList.SalesPermissions.get)} />
                <Route path="/expanse" element={RoutingComponent(Expanse, PermissionList.ExpansePermissions.get)} />
                <Route
                  path="/expanse/add"
                  element={RoutingComponent(AddExpanse, PermissionList.ExpansePermissions.get)}
                />
                <Route
                  path="/expanse/:id"
                  element={RoutingComponent(AddExpanse, PermissionList.ExpansePermissions.get)}
                />
                <Route path="/sales/:id" element={RoutingComponent(AddSale, PermissionList.SalesPermissions.get)} />
                <Route path="/purchases" element={RoutingComponent(Purchase, PermissionList.PurchasePermissions.get)} />
                <Route
                  path="/purchases/:id"
                  element={RoutingComponent(AddPurchase, PermissionList.PurchasePermissions.get)}
                />
                <Route path="/user-role-management" element={RoutingComponent(RoleUserManagement, PermissionList.RolePermissions.get)} />
                <Route path="/add-role" element={RoutingComponent(AddRole, PermissionList.RolePermissions.get)} />
                <Route path="/add-role/:id" element={RoutingComponent(AddRole, PermissionList.RolePermissions.get)} />
                {/* <Route path="/employees/add" element={RoutingComponent(AddUser)} /> */}
                <Route path="*" element={RoutingComponent(Dashboard, PermissionList.DashboardPermissions.get)} />
              </Routes>
              {/* </Main>
          </Box> */}
            </>
          ) : (
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/projectpreview" element={<ProjectPreview />} />
              <Route path="*" element={<Login />} />
            </Routes>
          )}
        </div>
      </SnackbarProvider>
    </LoadingProvider>
  );
}

export default App;
